export default "__VITE_ASSET__CUTljMny__"